document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initCifras();
  initGaleriaProducto();
  initVariantes();
  initPaquetes();
  initFlotante();
  initFlotanteProducto();
  initReubicarBotonReleasit();
  initSincronizarAlAbrirReleasit();
  initTestimoniosAuto();
  initVideosAutoplayScroll();
  initPagoTarjetaDirecto();
  initTiempoAnimado();
  initSeguimientoAdvertorial();
  initVideosModoAhorro();
});

function initTiempoAnimado() {
  // Anima la línea de tiempo (Pedido confirmado / Listo para envío /
  // Entregado en tu casa): los 3 pasos ya están visibles desde el inicio,
  // y lo que se anima es el "recorrido" — las líneas punteadas entre cada
  // paso se van uniendo de izquierda a derecha, una detrás de otra. Solo se
  // dispara una vez, la primera vez que la sección entra en pantalla.
  var el = document.querySelector('.mt-tiempo');
  if (!el) return;

  function activar() {
    el.classList.add('mt-tiempo-animar');
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    activar();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activar();
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.4 }
  );
  observer.observe(el);
}

/* Botón "Pagar en línea con tarjeta": sincroniza el carrito (dejando solo
   esta pelota con el paquete elegido, quitando cualquier otro producto que
   hubiera quedado antes) y va directo a pagar, aplicando el código de
   descuento por pagar con tarjeta.

   IMPORTANTE — por qué esto es distinto del primer intento (que hubo que
   revertir): este mismo formulario también contiene el botón de Releasit
   (Pagar contraentrega). La primera versión escuchaba el evento "submit"
   del FORMULARIO, y un <button> sin atributo "type" dentro de un <form> es
   "submit" por defecto en HTML — así que el clic en el botón de Releasit
   TAMBIÉN disparaba ese "submit" y terminaba secuestrado por este código.
   Esta versión en cambio escucha el CLIC directamente sobre nuestro propio
   botón (no el "submit" del formulario compartido), así que nunca se entera
   de nada relacionado con el botón de Releasit — quedan completamente
   aislados el uno del otro. */
function initPagoTarjetaDirecto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var boton = form.querySelector('[data-mt-boton-comprar]');
  if (!boton) return;
  var span = boton.querySelector('span');
  var textoInicial = span ? span.textContent : boton.textContent;
  var codigoDescuento = (form.getAttribute('data-codigo-descuento-tarjeta') || '').trim();
  var ocupado = false;

  function textoBoton(t) { if (span) span.textContent = t; else boton.textContent = t; }
  function error(msg) {
    var wrap = form.parentElement.querySelector('.product-form__error-message-wrapper');
    if (wrap) { wrap.hidden = false; var m = wrap.querySelector('.product-form__error-message'); if (m) m.textContent = msg; }
  }
  function reactivar() {
    ocupado = false;
    if (boton) { boton.disabled = false; textoBoton(textoInicial); }
  }
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) reactivar();
  });

  boton.addEventListener('click', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    if (ocupado) return;
    ocupado = true;
    boton.disabled = true; textoBoton('Un momento…');

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }];
    var cab = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Se limpia TODO lo que ya estuviera en el carrito antes de agregar
           —no solo otros productos, sino también cualquier cantidad vieja
           de esta misma pelota— porque Shopify SUMA la cantidad cuando se
           vuelve a añadir la misma variante en vez de reemplazarla. */
        var updates = {};
        (cart.items || []).forEach(function (it) { updates[it.variant_id] = 0; });
        var previo = Object.keys(updates).length
          ? fetch('/cart/update.js', { method: 'POST', headers: cab, body: JSON.stringify({ updates: updates }) })
          : Promise.resolve(null);
        return previo.then(function () { return fetch('/cart/add.js', { method: 'POST', headers: cab, body: JSON.stringify({ items: items }) }); });
      })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo añadir'); return j; }); })
      .then(function () {
        window.location.href = codigoDescuento
          ? '/checkout?discount=' + encodeURIComponent(codigoDescuento)
          : '/checkout';
      })
      .catch(function (e) {
        reactivar();
        error(e.message || 'Algo falló, inténtalo de nuevo.');
      });
  }, true);
}

function initVideosAutoplayScroll() {
  // Videos con data-mt-video-autoplay: se reproducen solos (siempre SIN sonido) al
  // entrar a la pantalla y se pausan al salir. Si el navegador bloquea el autoplay
  // (p. ej. Safari en iPhone con el modo de ahorro de batería), se muestra un botón
  // de play encima del video: un toque del usuario SÍ puede reproducirlo.
  var contenedores = document.querySelectorAll('[data-mt-video-autoplay]');
  if (!contenedores.length) return;

  function crearBoton(contenedor, video) {
    if (contenedor._mtPlay) return contenedor._mtPlay;
    if (window.getComputedStyle(contenedor).position === 'static') contenedor.style.position = 'relative';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Reproducir video');
    btn.style.cssText = 'position:absolute; inset:0; width:100%; height:100%; margin:0; padding:0; border:0; background:rgba(0,0,0,.18); cursor:pointer; display:none; align-items:center; justify-content:center; -webkit-tap-highlight-color:transparent;';
    btn.innerHTML = '<span style="display:flex; align-items:center; justify-content:center; width:64px; height:64px; border-radius:50%; background:rgba(255,253,248,.94); box-shadow:0 8px 22px rgba(0,0,0,.35);"><svg width="26" height="26" viewBox="0 0 24 24" fill="#C4402E" aria-hidden="true" style="margin-left:4px;"><path d="M8 5v14l11-7z"/></svg></span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
    contenedor.appendChild(btn);
    contenedor._mtPlay = btn;
    video.addEventListener('playing', function () { btn.style.display = 'none'; });
    return btn;
  }

  function intentar(contenedor, video) {
    video.playsInline = true;
    video.muted = true;
    var btn = crearBoton(contenedor, video);
    var p = video.play();
    var mostrar = function () { if (video.paused && !video.ended) btn.style.display = 'flex'; };
    if (p && p.catch) p.catch(mostrar);
    // Safari a veces no rechaza la promesa: se revisa de nuevo un momento después
    setTimeout(mostrar, 900);
  }

  // Un toque sobre el propio video también lo reproduce si está detenido
  contenedores.forEach(function (contenedor) {
    var video = contenedor.querySelector('video');
    if (!video) return;
    video.addEventListener('click', function () {
      if (video.paused) { video.muted = true; var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });

  if (!('IntersectionObserver' in window)) {
    contenedores.forEach(function (c) { var v = c.querySelector('video'); if (v) intentar(c, v); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          intentar(entry.target, video);
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  contenedores.forEach(function (contenedor) { observer.observe(contenedor); });
}

function initFlotanteProducto() {
  // Botón flotante de la página de producto: aparece cuando la persona
  // ya empezó a scrollear y el formulario de compra original no está a
  // la vista (todavía no llegó a él o ya quedó arriba). Al tocarlo, lleva de
  // vuelta al botón real de Releasit (con scroll suave) en vez de abrir
  // su formulario a control remoto — así el cliente siempre lo abre desde
  // donde ya está sincronizado con el paquete elegido, evitando el
  // problema de que apareciera sin ninguna cantidad seleccionada.
  var contenedor = document.querySelector('[data-mt-flotante-producto]');
  if (!contenedor) return;
  var referencia = document.querySelector('[data-mt-form-producto]');
  if (!referencia) return;

  // No aparece al entrar: solo después de que la persona empieza a
  // scrollear (unos 40 px) y mientras el formulario original no se ve.
  var haScrolleado = (window.pageYOffset || document.documentElement.scrollTop || 0) > 40;
  var formularioVisible = true;

  function actualizar() {
    contenedor.classList.toggle('mt-flotante-visible', haScrolleado && !formularioVisible);
  }

  if (!haScrolleado) {
    var alScrollear = function () {
      if ((window.pageYOffset || document.documentElement.scrollTop || 0) > 40) {
        haScrolleado = true;
        window.removeEventListener('scroll', alScrollear);
        actualizar();
      }
    };
    window.addEventListener('scroll', alScrollear, { passive: true });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        formularioVisible = entry.isIntersecting;
        actualizar();
      });
    },
    { threshold: 0 }
  );
  observer.observe(referencia);

  var trigger = contenedor.querySelector('[data-mt-flotante-producto-btn]');
  if (trigger) {
    trigger.addEventListener('click', function () {
      // Centra la tarjeta de 3 unidades en vez del botón de Releasit
      // directamente — así se ven las tres ofertas y el botón de compra al
      // mismo tiempo, en vez de llegar con el precio recortado arriba.
      var radioTres = document.querySelector('[data-mt-paquete-radio][data-cantidad="3"]');
      var tarjetaTres = radioTres ? radioTres.closest('[data-mt-paquete-card]') : null;
      if (tarjetaTres) {
        tarjetaTres.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        referencia.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
}

function initTestimoniosAuto() {
  // Carrusel de reseñas continuo: todas las tarjetas se desplazan juntas,
  // como una cinta, en bucle. Se mueve con transform (compositor), no con
  // scrollLeft, para que sea fluido en celulares. Se duplica el juego de
  // tarjetas una vez para que el bucle no tenga corte. No se detiene al tocarla
  // ni al hacer scroll (solo se detiene si la sección no está en pantalla).
  var tracks = document.querySelectorAll('[data-mt-test-track]');
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    var tarjetas = Array.prototype.slice.call(track.querySelectorAll('.mt-test-card'));
    if (tarjetas.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cinta = document.createElement('div');
    cinta.className = 'mt-test-cinta';
    cinta.style.gap = getComputedStyle(track).columnGap;
    tarjetas.forEach(function (t) { cinta.appendChild(t); });
    tarjetas.forEach(function (t) {
      var c = t.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      c.removeAttribute('id');
      cinta.appendChild(c);
    });
    track.appendChild(cinta);
    track.classList.add('mt-test-flujo');

    var segundosPorTarjeta = parseFloat(track.dataset.mtVelocidad) || 4;
    var pos = 0;
    var ultimo = 0;
    var pausado = false;
    var visible = false;
    var arrastrando = false;
    var reanudarTimer = null;

    // El ancho del juego se mide solo al inicio y al cambiar el tamaño
    // (leer offsetLeft en cada cuadro fuerza cálculo de layout).
    var anchoCache = 0;
    function medir() {
      anchoCache = cinta.children[tarjetas.length].offsetLeft - cinta.children[0].offsetLeft;
    }
    function anchoJuego() { if (!anchoCache) medir(); return anchoCache; }
    window.addEventListener('resize', function () { anchoCache = 0; });
    window.addEventListener('load', function () { anchoCache = 0; });
    var dpr = window.devicePixelRatio || 1;
    function normalizar(ancho) {
      if (ancho <= 0) return;
      pos = ((pos % ancho) + ancho) % ancho;
    }
    function pintar() {
      // Redondeado al píxel físico: texto nítido y sin temblor en pantallas retina
      cinta.style.transform = 'translate3d(' + (-Math.round(pos * dpr) / dpr) + 'px,0,0)';
    }

    function paso(ahora) {
      requestAnimationFrame(paso);
      if (pausado || arrastrando || !visible) { ultimo = 0; return; }
      if (!ultimo) { ultimo = ahora; return; }
      var dt = Math.min(ahora - ultimo, 64) / 1000;
      ultimo = ahora;
      var ancho = anchoJuego();
      if (ancho <= 0) return;
      // Una tarjeta (con su espacio) cada (segundos × 1,15)
      var velocidad = (ancho / tarjetas.length) / (segundosPorTarjeta * 1.15);
      pos += velocidad * dt;
      normalizar(ancho);
      pintar();
    }
    requestAnimationFrame(paso);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { visible = entry.isIntersecting; });
      }, { threshold: 0.1 }).observe(track);
    } else {
      visible = true;
    }

    // La cinta NO se pausa: sigue a la misma velocidad aunque la persona toque el carrusel,
    // haga scroll en la página o pase el mouse por encima.
  });
}

function initSincronizarAlAbrirReleasit() {
  // Releasit ahora se abre como ventana emergente (botón "PAGAR
  // CONTRAENTREGA"), así que sus radios de cantidad no existen en el DOM
  // hasta que el cliente la abre. Se sincroniza con la cantidad que el
  // cliente ya eligió arriba en las tarjetas durante una ventana corta
  // justo al abrirse (reintentando varias veces, no una sola), porque si
  // Releasit tiene configurada su propia "Preseleccionar esta oferta" a
  // veces la aplica de forma asíncrona un instante después de abrir el
  // formulario, revirtiendo una corrección hecha una sola vez. Pasada esa
  // ventana se deja de tocar por completo, para que el cliente pueda
  // cambiarla libremente dentro del formulario sin que el script se la
  // revierta (eso causaba un bucle infinito).
  var indicePorCantidad = { '1': '0', '2': '1', '3': '2' };
  var estabaAbierto = false;

  function releasitEstaAbierto() {
    return (
      !!document.getElementById('quantity_offer_0') ||
      !!document.getElementById('quantity_offer_1') ||
      !!document.getElementById('quantity_offer_2')
    );
  }

  function forzarSeleccion() {
    var cardActiva = document.querySelector('[data-mt-paquete-radio]:checked');
    if (!cardActiva) return;
    var cantidad = cardActiva.dataset.cantidad || '1';
    var indice = indicePorCantidad[cantidad];
    if (indice === undefined) return;
    var input = document.getElementById('quantity_offer_' + indice);
    if (!input || input.checked) return;
    var label = input.closest('label');
    if (label) label.click();
  }

  function sincronizarConReintentos() {
    var intentos = 0;
    var maxIntentos = 8;
    var idIntervalo = setInterval(function () {
      forzarSeleccion();
      intentos++;
      if (intentos >= maxIntentos) clearInterval(idIntervalo);
    }, 100);
  }

  var observer = new MutationObserver(function () {
    var abierto = releasitEstaAbierto();
    if (abierto && !estabaAbierto) {
      sincronizarConReintentos();
    }
    estabaAbierto = abierto;
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (releasitEstaAbierto()) {
    estabaAbierto = true;
    sincronizarConReintentos();
  }
}

function initReubicarBotonReleasit() {
  function reubicar() {
    var candidatos = document.querySelectorAll('#rsi_buy_now_button');
    var boton = null;
    candidatos.forEach(function (el) {
      if (el.closest('product-form')) boton = el;
    });
    if (!boton) return;

    var form = boton.closest('form');
    if (!form) return;
    if (form.firstElementChild === boton) return;

    boton.style.setProperty('margin-top', '24px', 'important');
    boton.style.setProperty('margin-bottom', '14px', 'important');
    form.insertBefore(boton, form.firstElementChild);
  }

  reubicar();

  var observer = new MutationObserver(function () {
    reubicar();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function initFlotante() {
  var boton = document.querySelector('[data-mt-flotante]');
  if (!boton) return;
  var hero = document.querySelector('.mt-hero');
  var cierre = document.querySelector('.mt-cierre');
  if (!hero || !cierre) return;

  var heroPasado = false;
  var cierreAlcanzado = false;

  function actualizar() {
    if (heroPasado && !cierreAlcanzado) {
      boton.classList.add('mt-flotante-visible');
    } else {
      boton.classList.remove('mt-flotante-visible');
    }
  }

  var heroObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        heroPasado = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        actualizar();
      });
    },
    { threshold: 0 }
  );
  heroObserver.observe(hero);

  var cierreObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        cierreAlcanzado = entry.isIntersecting;
        actualizar();
      });
    },
    { threshold: 0 }
  );
  cierreObserver.observe(cierre);
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.01, rootMargin: '0px 0px 120px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
  // Red de seguridad: si al cargar ya hay elementos visibles en pantalla
  // (o casi, por diferencias de layout), fuérzalos a mostrarse.
  window.addEventListener('load', function () {
    els.forEach(function (el) {
      if (el.classList.contains('mt-visible')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight + 300 && r.bottom > -300) {
        el.classList.add('mt-visible');
        observer.unobserve(el);
      }
    });
  });
}

function initCifras() {
  var els = document.querySelectorAll('.mt-cifra[data-fin]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.dataset.fin) || 0;
        var sufijo = el.dataset.sufijo || '';
        if (reduced) {
          el.textContent = fin + sufijo;
          observer.unobserve(el);
          return;
        }
        var inicio = 0;
        var duracion = 1400;
        var t0 = null;
        function paso(ts) {
          if (!t0) t0 = ts;
          var progreso = Math.min((ts - t0) / duracion, 1);
          var valor = Math.round(inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3)));
          el.textContent = valor + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var track = galeria.querySelector('[data-mt-carrusel-track]');
  var slides = galeria.querySelectorAll('[data-mt-carrusel-slide]');
  var dots = galeria.querySelectorAll('[data-mt-carrusel-dot]');
  var prevBtn = galeria.querySelector('[data-mt-carrusel-prev]');
  var nextBtn = galeria.querySelector('[data-mt-carrusel-next]');
  if (!track || !slides.length) return;

  function indiceActual() {
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function irA(indice) {
    indice = Math.max(0, Math.min(slides.length - 1, indice));
    // scrollLeft del track, no scrollIntoView: este último puede arrastrar
    // el scroll vertical de toda la página, no solo el carrusel.
    track.scrollLeft = slides[indice].offsetLeft;
  }

  function actualizarDots() {
    var indice = indiceActual();
    dots.forEach(function (d, i) {
      d.classList.toggle('mt-dot-activo', i === indice);
      d.style.background = i === indice ? 'var(--mt-color-acento)' : 'var(--mt-color-borde)';
      d.style.width = i === indice ? '20px' : '8px';
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { irA(indiceActual() - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { irA(indiceActual() + 1); });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () { irA(i); });
  });

  var scrollTimeout;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(actualizarDots, 80);
  });

  window.addEventListener('resize', function () {
    irA(indiceActual());
  });
}

function initVariantes() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var selects = form.querySelectorAll('[data-mt-opcion]');
  if (!selects.length) return;
  var variantesJson = form.querySelector('[data-mt-variantes]');
  if (!variantesJson) return;
  var variantes;
  try {
    variantes = JSON.parse(variantesJson.textContent);
  } catch (e) {
    return;
  }
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-comparado]');
  var botonEl = document.querySelector('[data-mt-boton-comprar]');

  function seleccionActual() {
    var valores = [];
    selects.forEach(function (s) { valores.push(s.value); });
    return valores;
  }

  function actualizar() {
    var valores = seleccionActual();
    var match = variantes.find(function (v) {
      return v.options.length === valores.length && v.options.every(function (o, i) { return o === valores[i]; });
    });
    if (!match) return;
    inputId.value = match.id;
    if (precioEl && match.price_formatted) precioEl.textContent = match.price_formatted;
    if (precioCompareEl) {
      if (match.compare_at_price_formatted) {
        precioCompareEl.textContent = match.compare_at_price_formatted;
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      var span = botonEl.querySelector('span');
      if (match.available) {
        botonEl.disabled = false;
        botonEl.removeAttribute('disabled');
        if (span) span.textContent = botonEl.dataset.textoDisponible || 'Añadir al carrito';
      } else {
        botonEl.disabled = true;
        botonEl.setAttribute('disabled', 'disabled');
        if (span) span.textContent = botonEl.dataset.textoAgotado || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initPaquetes() {
  var radios = document.querySelectorAll('[data-mt-paquete-radio]');
  if (!radios.length) return;

  var tarjetaVariantInput = document.querySelector('[data-mt-tarjeta-variant]');
  var cantidadInput = document.querySelector('[data-mt-cantidad]');
  var sincronizando = false;
  var indicePorCantidad = { '1': '0', '2': '1', '3': '2' };
  var cantidadPorIndice = { '0': '1', '1': '2', '2': '3' };

  function labelReleasitParaCantidad(cantidad) {
    var indice = indicePorCantidad[cantidad];
    if (indice === undefined) return null;
    var input = document.getElementById('quantity_offer_' + indice);
    return input ? input.closest('label') : null;
  }

  function aplicarSeleccion(radio, sincronizarReleasit) {
    radios.forEach(function (r) {
      var card = r.closest('[data-mt-paquete-card]');
      if (!card) return;
      if (r === radio) {
        card.classList.add('mt-paquete-activo');
        // Estilo en línea, no solo la clase CSS: así queda garantizado
        // que se vea la tarjeta seleccionada aunque la regla de la hoja
        // de estilos no se aplique por algún motivo. Se fija el "border"
        // completo (no solo border-color) porque el navegador vacía el
        // border-style/width heredado del shorthand si solo se toca
        // border-color con !important, dejando el borde invisible.
        card.style.setProperty('border', '2px solid #c4402e', 'important');
        card.style.setProperty('box-shadow', '0 0 0 3px rgba(196, 64, 46, 0.25)', 'important');
      } else {
        card.classList.remove('mt-paquete-activo');
        // Se fija el borde neutro explícito (no solo se quita), porque
        // quitarlo dejaría la tarjeta sin ningún borde de respaldo.
        card.style.setProperty('border', '2px solid var(--mt-color-borde)', 'important');
        card.style.setProperty('box-shadow', 'none', 'important');
      }
      r.checked = r === radio;
    });

    var variantId = radio.value;
    var cantidad = radio.dataset.cantidad || '1';

    if (tarjetaVariantInput) {
      tarjetaVariantInput.value = variantId;
      tarjetaVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (cantidadInput) {
      cantidadInput.value = cantidad;
      cantidadInput.dispatchEvent(new Event('change', { bubbles: true }));
      cantidadInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (sincronizarReleasit !== false && !sincronizando) {
      var label = labelReleasitParaCantidad(cantidad);
      if (label) {
        sincronizando = true;
        label.click();
        setTimeout(function () { sincronizando = false; }, 80);
      }
    }

    document.dispatchEvent(
      new CustomEvent('mt:paquete-cambiado', {
        detail: { variantId: variantId, cantidad: cantidad, nombre: radio.dataset.nombre, precio: radio.dataset.precio },
      })
    );
  }

  radios.forEach(function (r) {
    r.addEventListener('change', function () { aplicarSeleccion(r, true); });
  });

  // Si el cliente cambia la cantidad directamente dentro del formulario de
  // Releasit (pago contraentrega), reflejar esa selección en las tarjetas.
  // Releasit es una app en React: no dispara "change" en el radio nativo,
  // solo "click" — y tarda un momento en recalcular su total. Por eso se
  // escucha "click" y se lee el resultado después de una breve espera.
  document.addEventListener('click', function (evento) {
    if (sincronizando) return;
    var label = evento.target.closest('label[for^="quantity_offer_"]');
    if (!label) return;
    // Releasit tarda un poco (y a veces más de lo normal si acaba de
    // recalcular otra selección) en confirmar su nuevo estado interno.
    // Se revisa varias veces en vez de una sola lectura a tiempo fijo.
    var intentos = 0;
    var intervalo = setInterval(function () {
      intentos++;
      var indiceSeleccionado = null;
      ['0', '1', '2'].forEach(function (i) {
        var input = document.getElementById('quantity_offer_' + i);
        if (input && input.checked) indiceSeleccionado = i;
      });
      var cantidad = cantidadPorIndice[indiceSeleccionado];
      if (cantidad) {
        var radioCoincide = null;
        radios.forEach(function (r) {
          if ((r.dataset.cantidad || '1') === cantidad) radioCoincide = r;
        });
        if (radioCoincide && !radioCoincide.checked) {
          aplicarSeleccion(radioCoincide, false);
        }
        if (radioCoincide && radioCoincide.checked) {
          clearInterval(intervalo);
          return;
        }
      }
      if (intentos >= 30) clearInterval(intervalo);
    }, 150);
  }, true); // fase de captura: Releasit detiene la propagación del clic en fase de burbuja

  var inicial = document.querySelector('[data-mt-paquete-radio]:checked') || radios[0];
  aplicarSeleccion(inicial, false);
}

function initSeguimientoAdvertorial() {
  // Mide el paso advertorial → producto. Los enlaces de los advertoriales llevan
  // ?src=adv-xxx. Se envían dos eventos personalizados al Pixel de Meta
  // (y a Shopify Customer Events con Shopify.analytics.publish):
  //   AdvertorialClick   — clic en un botón del advertorial (antes de salir)
  //   AdvertorialArrival — llegada a la página de producto con ?src=adv-xxx (1 vez por sesión)
  function enviar(nombre, datos) {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', nombre, datos);
        // Además, un evento con el nombre del advertorial (p. ej. AdvertorialClick_FetchBall_Gata)
        // para poder verlos por separado en el Administrador de eventos de Meta.
        if (datos && datos.advertorial) {
          var mapa = { 'adv-solo': 'Correlon', 'adv-fb-gato': 'FetchBall_Gata', 'adv-fb-perro': 'FetchBall_Perro', 'adv-fb-amigo': 'FetchBall_Amigo', 'adv-fb-adiestrador': 'FetchBall_Adiestrador', 'adv-fb-ciencia': 'FetchBall_Ciencia', 'adv-fb-duenos': 'FetchBall_Duenos' };
          var etiqueta = mapa[datos.advertorial] || String(datos.advertorial).replace(/[^a-z0-9]+/gi, '_');
          window.fbq('trackCustom', nombre + '_' + etiqueta, datos);
        }
      }
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('custom_' + nombre.toLowerCase(), datos);
      }
    } catch (e) {}
  }
  function srcDe(href) {
    try {
      var u = new URL(href, window.location.href);
      var v = u.searchParams.get('src');
      return v && v.indexOf('adv') === 0 ? v : null;
    } catch (e) { return null; }
  }

  // 1) Clic en cualquier enlace con ?src=adv-...
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="src=adv"]') : null;
    if (!a) return;
    var src = srcDe(a.getAttribute('href'));
    if (!src) return;
    enviar('AdvertorialClick', {
      advertorial: src,
      boton: (a.textContent || '').trim().slice(0, 60),
      pagina: window.location.pathname
    });
  }, true);

  // 2) Llegada al producto desde un advertorial
  if (window.location.pathname.indexOf('/products/') === 0) {
    var src = srcDe(window.location.href);
    if (src) {
      var clave = 'cordelo_adv_llegada_' + src;
      var yaEnviado = false;
      try { yaEnviado = window.sessionStorage.getItem(clave) === '1'; } catch (e) {}
      if (!yaEnviado) {
        try { window.sessionStorage.setItem(clave, '1'); } catch (e) {}
        // fbq puede tardar un instante en estar listo
        var intentos = 0;
        var t = setInterval(function () {
          intentos++;
          if (typeof window.fbq === 'function' || intentos >= 20) {
            clearInterval(t);
            enviar('AdvertorialArrival', { advertorial: src, producto: window.location.pathname });
          }
        }, 250);
      }
    }
  }
}

function initVideosModoAhorro() {
  // Safari en iPhone con "Modo de bajo consumo / ahorro de batería" bloquea el autoplay
  // de TODOS los videos. Si un video que debería arrancar solo no arranca, se le muestran
  // los controles nativos (botón de play); un toque de la persona sí puede reproducirlo.
  // En cuanto empieza a reproducirse, los controles se ocultan de nuevo.
  // (Los videos de la ficha de FetchBall con data-mt-video-autoplay tienen su propio botón.)
  var videos = Array.prototype.slice.call(document.querySelectorAll('video')).filter(function (v) {
    if (v.closest && v.closest('[data-mt-video-autoplay]')) return false;
    return v.autoplay || v.hasAttribute('autoplay') || v.classList.contains('cr-video-libre') || (v.closest && v.closest('.adv-video'));
  });
  if (!videos.length) return;

  function revisar(v) {
    if (!v.paused || v.ended) return;
    v.controls = true;
  }
  function intentar(v) {
    v.muted = true;
    v.playsInline = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { revisar(v); });
    setTimeout(function () { revisar(v); }, 1300);
  }
  videos.forEach(function (v) {
    v.addEventListener('playing', function () { v.controls = false; });
  });

  if (!('IntersectionObserver' in window)) { videos.forEach(intentar); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) intentar(e.target); });
  }, { threshold: 0.3 });
  videos.forEach(function (v) { io.observe(v); });
}
